import { request } from '@/utils/request'
const BossService = {
  state: {},

  mutations: {},

  actions: {
    GetInformation({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('/api/tongji/v2/GetInformation',
          params
        ).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetXunJianTongJi({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('/api/tongji/v2/GetXunJianTongJi',
          params
        ).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetBaoJingTongJi({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('/api/tongji/v2/GetBaoJingTongJi',
          params
        ).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetYinHuanChuLi({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('/api/tongji/v2/GetYinHuanChuLi',
          params
        ).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetProjectMapInfo({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('/api/tongji/v2/GetProjectMapInfo',
          params
        ).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetZongGongDianLiang({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('/api/tongji/v2/GetZongGongDianLiang',
          params
        ).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetXinNengYuanFaDianLiang({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('/api/tongji/v2/GetXinNengYuanFaDianLiang',
          params
        ).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetWangGouDianLiang({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('/api/tongji/v2/GetWangGouDianLiang',
          params
        ).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}
export default BossService
